'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var slicedToArray = require('./../../../external/@babel/runtime/helpers/esm/slicedToArray.js');
var React = require('react');
var index = require('./../../../external/classnames/index.js');
var PropTypes = require('prop-types');
require('../../../composites/Card/Card.js');
require('../../../composites/Card/CardImage/CardImage.js');
require('../../../composites/Card/CardText/CardText.js');
require('../../../composites/Card/CardTitle/CardTitle.js');
require('../../../composites/Carousel/Carousel.js');
require('../../../composites/Carousel/CarouselControl/CarouselControl.js');
require('../../../composites/Carousel/CarouselIndicator/CarouselIndicator.js');
require('../../../composites/Carousel/CarouselIndicators/CarouselIndicators.js');
require('../../../composites/Carousel/CarouselItem/CarouselItem.js');
require('../../../composites/Carousel/CarouselInner/CarouselInner.js');
require('../../../composites/EventCard/EventCard.js');
require('../../../composites/EventCard/EventGrid/EventGrid.js');
var Modal = require('../../../composites/Modal/Modal.js');
var ModalBody = require('../../../composites/Modal/ModalBody/ModalBody.js');
require('../../../composites/Modal/ModalFooter/ModalFooter.js');
require('../../../composites/Modal/ModalHeader/ModalHeader.js');
require('../../../composites/SearchBar/SearchBar.js');
var Video = require('../../../composites/Video/Video.js');
var useMobileBool = require('../../../utilities/hooks/useMobileBool.js');
var MediaListItem = require('../MediaListItem/MediaListItem.js');

function _interopDefault (e) { return e && e.__esModule ? e : { default: e }; }

var React__default = /*#__PURE__*/_interopDefault(React);
var PropTypes__default = /*#__PURE__*/_interopDefault(PropTypes);

var MediaListItemVideo = function MediaListItemVideo(props) {
  var btnTitle = props.btnTitle,
    className = props.className,
    href = props.href,
    videoId = props.videoId,
    videoDuration = props.videoDuration,
    thumbnail_quality = props.thumbnail_quality,
    title = props.title,
    sectionTitle = props.sectionTitle,
    subtitle = props.subtitle,
    empty = props.empty;
  var classes = index.default('lanl-media-list-item-video', !subtitle && 'no-subtitle', className);
  var _useState = React.useState(false),
    _useState2 = slicedToArray.default(_useState, 2),
    modalIsOpen = _useState2[0],
    setModalIsOpen = _useState2[1];
  var openModal = function openModal(e) {
    e.preventDefault();
    setModalIsOpen(true);
  };
  return /*#__PURE__*/React__default.default.createElement(MediaListItem.MediaListItem, {
    className: classes,
    "data-testid": "lanl-media-list-item-video",
    href: href,
    title: title,
    btnTitle: btnTitle,
    subtitle: subtitle,
    empty: empty,
    sectionTitle: sectionTitle,
    openModal: openModal
  }, /*#__PURE__*/React__default.default.createElement(Video.Video, {
    videoFeatureImageSrc: "https://img.youtube.com/vi/".concat(videoId, "/").concat(thumbnail_quality !== null && thumbnail_quality !== void 0 ? thumbnail_quality : 'sddefault', ".jpg"),
    time: videoDuration,
    onClickCB: function onClickCB() {
      return setModalIsOpen(true);
    },
    className: "div-video"
  }), /*#__PURE__*/React__default.default.createElement(Modal.Modal, {
    isOpen: modalIsOpen,
    toggle: function toggle() {
      return setModalIsOpen(false);
    },
    size: useMobileBool.useMobileBool() ? 'fluid' : 'xl',
    centered: true
  }, /*#__PURE__*/React__default.default.createElement(ModalBody.ModalBody, null, /*#__PURE__*/React__default.default.createElement("iframe", {
    title: title,
    src: "https://youtube.com/embed/".concat(videoId, "?rel=0&controls=0&modestBranding=1"),
    className: "video-iframe"
  }))));
};
MediaListItemVideo.defaultProps = {
  btnTitle: 'Watch Now'
};
MediaListItemVideo.propTypes = {
  href: PropTypes__default.default.string.isRequired,
  subtitle: PropTypes__default.default.string.isRequired,
  title: PropTypes__default.default.string.isRequired,
  btnTitle: PropTypes__default.default.string,
  className: PropTypes__default.default.string,
  empty: PropTypes__default.default.bool,
  sectionTitle: PropTypes__default.default.string,
  videoDuration: PropTypes__default.default.string,
  videoId: PropTypes__default.default.string
};

exports.MediaListItemVideo = MediaListItemVideo;
exports.default = MediaListItemVideo;
//# sourceMappingURL=MediaListItemVideo.js.map
